"use client";
import g from "js-cookie";
import _, { HTTPError as l } from "ky";
import { useReducer as T } from "react";
import { useStore as w } from "@nanostores/react";
import { atom as y, onSet as U } from "nanostores";
const d = {
  get(e) {
    const r = g.get(e);
    if (r) return JSON.parse(r);
  },
  reset(e) {
    g.remove(e);
  },
  update(
    e,
    r,
    t = {
      expires: 90,
    },
  ) {
    return g.set(e, JSON.stringify(r), t), r;
  },
};
var i = /* @__PURE__ */ ((e) => (
  (e.LOADING = "loading"),
  (e.FIELD = "field"),
  (e.EMAIL_SUBMIT = "submitEmail"),
  (e.OTP_SUBMIT = "submitOtp"),
  (e.EMAIL_ERROR = "emailError"),
  (e.OTP_ERROR = "otpError"),
  (e.OTP_EXPIRED = "otpTimeout"),
  (e.EMAIL_SUCCESS = "emailSuccess"),
  (e.OTP_SUCCESS = "otpSuccess"),
  (e.RESET = "reset"),
  e
))(i || {});
const M = {
  activeField: "email",
  didError: !1,
  email: "",
  emailErrorMessage: "",
  otpErrorMessage: "",
  isLoading: !1,
  otp: "",
  otpSuccess: !1,
  success: !1,
};
function P(e, r) {
  switch (r.type) {
    case "loading":
      return {
        ...e,
        didError: !!(e.emailErrorMessage || e.otpErrorMessage),
        isLoading: !0,
      };
    case "reset":
      return {
        ...e,
        didError: !1,
        emailErrorMessage: "",
        otp: "",
        otpErrorMessage: "",
        isLoading: !1,
        activeField: "email",
      };
    case "field":
      return r.field
        ? {
            ...e,
            didError: !!(e.emailErrorMessage || e.otpErrorMessage),
            [r.field]: r.value,
          }
        : {
            ...e,
            didError: !!(e.emailErrorMessage || e.otpErrorMessage),
          };
    case "submitEmail":
      return {
        ...e,
        didError: !1,
        emailErrorMessage: "",
        otpErrorMessage: "",
        isLoading: !0,
      };
    case "emailError":
      return {
        ...e,
        didError: !0,
        emailErrorMessage: r.value,
        otpErrorMessage: "",
        isLoading: !1,
      };
    case "emailSuccess":
      return {
        ...e,
        didError: !1,
        emailErrorMessage: "",
        otpErrorMessage: "",
        isLoading: !1,
        activeField: "otp",
      };
    case "submitOtp":
      return {
        ...e,
        didError: !1,
        emailErrorMessage: "",
        otpErrorMessage: "",
        isLoading: !0,
      };
    case "otpError":
      return {
        ...e,
        didError: !0,
        emailErrorMessage: "",
        otpErrorMessage: r.value,
        isLoading: !1,
      };
    case "otpTimeout":
      return {
        ...e,
        didError: !0,
        emailErrorMessage:
          "Your session has expired. Please restart the sign in process",
        otp: "",
        otpErrorMessage: "",
        isLoading: !1,
        activeField: "email",
      };
    case "otpSuccess":
      return {
        ...e,
        isLoading: !1,
        emailErrorMessage: "",
        otpErrorMessage: "",
        otpSuccess: !0,
        success: !0,
        activeField: "otp",
      };
    default:
      throw new Error(`Unhandled action type - ${JSON.stringify(r)}`);
  }
}
const f = "upAuthDidSignIn",
  R = "upAuthDidSignOut",
  v = "up-uri-before-auth-failure",
  S = "/id/auth/signin",
  k = "/id/auth/refresh_token",
  p = "_up-user-id",
  n = {
    get() {
      return d.get(p);
    },
    reset() {
      return d.reset(p);
    },
    update(e, r) {
      return d.update(p, e, r), e;
    },
  };
function I(e, r) {
  const t = new CustomEvent(e);
  document.dispatchEvent(t);
}
function O(e, r) {
  const t = JSON.parse(window.atob(r.split(".")[1]));
  return e.toLowerCase() === "id" ? t.sub : t[e];
}
function C() {
  const e = n.get();
  if (!e) return;
  const r = sessionStorage.getItem("id"),
    t = sessionStorage.getItem("it"),
    o = sessionStorage.getItem("ac");
  return {
    ...e,
    id: r,
    it: t,
    at: o,
  };
}
let m = "/";
async function h(e, r) {
  try {
    if (!r?.rt) {
      E();
      return;
    }
    const t = await e
      .post(m + k, {
        json: {
          email: r.email,
          domain: r.domain,
          token: r.rt,
        },
      })
      .json();
    return (
      sessionStorage.setItem("id", O("id", t.IdToken)),
      sessionStorage.setItem("it", t.IdToken),
      sessionStorage.setItem("at", t.AccessToken),
      n.update({
        email: r.email,
        domain: r.domain,
        rt: r.rt,
      })
    );
  } catch (t) {
    throw (
      ((!(t instanceof l) || t.response?.status !== 422) && console.error(t), t)
    );
  }
}
function L() {
  const e = (o) => {
      const a = sessionStorage.getItem("it");
      a && o.headers.set("Authorization", `Bearer ${a}`);
    },
    r = async (o, a, s) => {
      if (s.status === 401 && !o.url.match(S))
        try {
          await h(t, n.get());
          const u = sessionStorage.getItem("it");
          return u && o.headers.set("Authorization", `Bearer ${u}`), _(o);
        } catch (u) {
          return E(), Promise.reject(u);
        }
    },
    t = _.create({
      headers: {
        Accept: "application/json",
      },
      hooks: {
        beforeRequest: [e],
        afterResponse: [r],
      },
    });
  return {
    currentUser: C(),
    client: t,
    uriBeforeFailure: d.get(v) ?? "/",
  };
}
const c = y(L()),
  H = () => w(c);
U(c, ({ newValue: e }) => {
  d.update(v, e.uriBeforeFailure);
});
if (typeof document < "u") {
  const e = () => {
    c.set(L());
  };
  document.addEventListener(f, e), document.addEventListener(R, e);
}
async function F(e, r) {
  const t = c.get(),
    o = n.get();
  if (!o || !o.email || !o.domain) {
    E();
    return;
  }
  try {
    const a = {
        ...(r ?? {}),
        ...o,
        otp: e,
      },
      s = await t.client.post(m + "" + S, { json: a }).json();
    return (
      sessionStorage.setItem("id", O("id", s.IdToken)),
      sessionStorage.setItem("it", s.IdToken),
      sessionStorage.setItem("at", s.AccessToken),
      n.update({
        email: o.email,
        domain: o.domain,
        rt: s.RefreshToken,
      }),
      I(f),
      c.get()
    );
  } catch (a) {
    throw (
      (a instanceof l &&
        a.response.status === 401 &&
        n.update({
          email: o.email,
          domain: o.domain,
          session: o.session,
        }),
      a)
    );
  }
}
async function A(e, r) {
  const o = await c
    .get()
    .client.post(m + S, {
      json: {
        email: e,
        domain: r,
      },
    })
    .json();
  return n.update({
    email: o.email ?? e,
    domain: r,
    session: o.session,
  });
}
function E() {
  n.reset(),
    sessionStorage.removeItem("id"),
    sessionStorage.removeItem("it"),
    sessionStorage.removeItem("ac"),
    sessionStorage.removeItem("at"),
    I(R);
}
const $ = async (e) => {
    const r = n.get();
    await h(e, r);
  },
  x = (e) => {
    m = e;
  },
  G = async (e) => {
    const r = n.get(),
      t = {
        ...r,
        // TODO: bad typing; fix it JERRY
        domain: r.domain,
        email: e,
      };
    n.update(t), await h(c.get().client, t), I(f);
  },
  J = function (e) {
    const [r, t] = T(P, {
        ...M,
        email: e?.initialState?.email ?? M.email,
        otpMetadata: e?.initialState?.otpMetadata ?? {},
      }),
      o = async function () {
        if ((t({ type: i.EMAIL_SUBMIT }), !r.email || r.email === " ")) {
          t({
            type: i.EMAIL_ERROR,
            value: "Please enter an email address",
          });
          return;
        }
        try {
          if (await A(r.email, window.location.hostname))
            t({ type: i.EMAIL_SUCCESS });
          else throw new Error("Error");
        } catch (s) {
          if ((e.onException?.(s), s instanceof l)) {
            const { message: u } = await s.response.json();
            t({ type: i.EMAIL_ERROR, value: u });
          } else
            t({
              type: i.EMAIL_ERROR,
              value: "Error",
            });
        }
      },
      a = async function () {
        t({ type: i.OTP_SUBMIT });
        try {
          const s = await F(r.otp, r.otpMetadata);
          if (s) t({ type: i.OTP_SUCCESS }), e.onSuccess?.(s);
          else throw new Error("Error");
        } catch (s) {
          if ((e.onException?.(s), s instanceof l)) {
            if (s.response?.status === 401) {
              t({
                type: i.OTP_ERROR,
                value: "One-time password is incorrect",
              });
              return;
            }
            if (s.response?.status === 403) {
              t({
                type: i.OTP_EXPIRED,
              });
              return;
            }
          }
          t({
            type: i.OTP_ERROR,
            value: "Error",
          });
        }
      };
    return {
      ...r,
      onSubmit(s) {
        s.preventDefault(),
          !r.isLoading &&
            (r.activeField === "email" ? o() : r.activeField === "otp" && a());
      },
      onChange(s) {
        const u = s.target;
        t({
          type: i.FIELD,
          field: u.name,
          value: u.value,
        });
      },
      reset() {
        E(),
          t({
            type: i.RESET,
          });
      },
    };
  };
export {
  i as ActionType,
  f as UP_AUTH_DID_SIGN_IN,
  R as UP_AUTH_DID_SIGN_OUT,
  c as authStore,
  F as confirmOTP,
  d as cookieService,
  L as generateStore,
  M as initialState,
  P as reducer,
  $ as refreshToken,
  x as setBaseURL,
  A as signIn,
  E as signOut,
  G as updateEmail,
  H as useAuthStore,
  J as useLogin,
};
//# sourceMappingURL=index.es.js.map
